import { useCallback } from 'react';
import { User } from 'api/models';
import { Action, EventType, ObjectType } from 'api/pushes';
import { AccountSocketData } from 'api/pushes/models';
import { logger } from 'services';
import { addMember, deleteMember, updateMember } from 'utils/idb-utils';
import { useAccountWsUpdates } from '../use-account-ws-updates';

export const useAccountSettingsMembersWsUpdates = (): void => {
  const handleUserAdd = useCallback(
    async (
      socketData: AccountSocketData<{
        user: User;
      }>,
    ) => {
      addMember(socketData?.data?.user).catch((err) => {
        logger.error(
          'Error occured while inserting new member in indexedDB in settings page',
          err,
        );
      });
    },
    [],
  );

  const handleUserUpdate = useCallback(
    async (socketData: AccountSocketData<{ user: User }>) => {
      updateMember(socketData?.data?.user).catch((err) => {
        logger.error(
          'Error occured while updating new member in indexedDB in settings page',
          err,
        );
      });
    },
    [],
  );

  const handleUserDelete = useCallback(
    async (socketData: AccountSocketData<{ user: User }>) => {
      await deleteMember(socketData?.data?.user?.userId).catch((err) => {
        logger.error(
          'Error occured while deleting new member in indexedDB in settings page',
          err,
        );
      });
    },
    [],
  );

  useAccountWsUpdates(
    handleUserAdd,
    EventType(Action.Create, ObjectType.AccountMembers),
  );

  useAccountWsUpdates(
    handleUserUpdate,
    EventType(Action.Update, ObjectType.AccountMembers),
  );

  useAccountWsUpdates(
    handleUserDelete,
    EventType(Action.Delete, ObjectType.AccountMembers),
  );
};
